import PropTypes from 'prop-types';
import React from 'react';
import { get, pageContext } from 'ctm-util-functions';
import { TextTemplate } from '../text_template/text_template';
import { ModalContainer } from '../modal/modal_container';
import { SimpleFlexbox } from '../flexbox/flexbox';
import { BrandLogo } from '../brand_logo/brand_logo';
import style from './special_offer.css';

/**
 * The special offer component - with a configurable label, variant, and terms modal button
 * Discount model within the product object will look like the following:
 * discount: {
 *     discountOffer: string,
 *     discountOfferTerms: formatted HTML,
 *     offline: value,
 *     online: value
 * }
 * @param {Object} props The properties
 * @param {Object} props.visualProps A variant to display alternate styles (schema defined)
 * @param {Object} props.contentProps A label
 * @param {Object} props.stateProps - The stateful product object passed in via container
 * @returns {Node} The special offer component
 * @constructor
 */
const SpecialOffer = ({ visualProps = {}, contentProps = {}, modalProps = {}, stateProps }) => {
    const { stateKey } = contentProps;
    const { variant = 'default' } = visualProps;
    const discount = get(stateProps, stateKey);
    const { product } = stateProps;
    const { everestTheme } = pageContext.getProps();
    const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${pageContext.getVertical()}` };

    let showSpecialOffer = (get(discount, 'offline') > 0 || get(discount, 'online') > 0);
    // If offline/online are not defined (Car) check if there is a discount object
    if (get(discount, 'offline') === undefined || get(discount, 'online') === undefined) {
        showSpecialOffer = !!discount;
    }

    if (!get(discount, 'discountOffer') && !get(discount, 'discountOfferTerms')) {
        showSpecialOffer = false;
    }
    const textContentClass = everestTheme === 'choo' ? style.content_choo : style.content;

    return showSpecialOffer ? (
        <div className={style[variant]}>
            <span className={textContentClass}>
                {discount.get('discountOffer')}
&nbsp;
            </span>
            { discount.get('discountOfferTerms')
            && (
                <ModalContainer {...modalProps}>
                    <SimpleFlexbox display="flex">
                        <BrandLogo stateProps={{ product }} elementProps={brandLogoElementProps} />
                        <h3 className={style.modal_title}>{product.getIn(['productMeta', 'name'])}</h3>
                    </SimpleFlexbox>
                    <TextTemplate innerHTML={discount.get('discountOfferTerms')} size="medium" color="brand_base" />
                </ModalContainer>
            ) }
        </div>
    ) : <div className={style[`${variant}_placeholder`]} />;
};

SpecialOffer.propTypes = {
    contentProps: PropTypes.shape({
        stateKey: PropTypes.string
    }),
    stateProps: PropTypes.shape({
        product: PropTypes.object
    }),
    modalProps: PropTypes.shape({
        openComponent: PropTypes.array,
        stateProps: PropTypes.object
    }),
    visualProps: PropTypes.shape({
        variant: PropTypes.string
    })
};

export { SpecialOffer };
